// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "(max-width: 768px)";
var _5 = "passengers-THp1a";
var _6 = "passengers_recommend-3D1VF";
var _7 = "passengers_mobile-3_qLN";
var _8 = "passenger_fixed-1L64r";
var _9 = "passenger_stickToBottom-2M5fW";
var _a = "passenger-16w2X";
var _b = "passenger__name-adPm8";
var _c = "free-3Vd8P";
var _d = "passenger__name__value-vA5gt";
var _e = "passenger__cancel-29Rt-";
var _f = "passenger__seat-FS9I0";
var _10 = "passenger__price-2-_T7";
var _11 = "passenger_selected-aHAFG";
var _12 = "disclaimer-G0D4Q";
var _13 = "passenger__icon-2SPny";
var _14 = "passenger_withoutSeat-b4y00";
var _15 = "passenger_with_seat-2hyvN";
var _16 = "passenger_with_confirmed_seat-3RdpM";
var _17 = "passengers__footer-2LxGf";
var _18 = "passengers__buttons-2tCZY";
var _19 = "passengers__button-2b0I6";
var _1a = "passengers__button_clear-cPcpO";
var _1b = "info__icon-2BViO";
var _1c = "disclaimer__paragraph-njEfZ";
var _1d = "recommend-2xyp-";
var _1e = "recommend__icon-3laLb";
var _1f = "recommend__wrapper-8alQR";
var _20 = "recommend__label-BoBeO";
var _21 = "together-2oQz5";
var _22 = "recommend__price-3FBdZ";
var _23 = "passengers__doubleSeat-rQG3n";
var _24 = "notifications-1a8Oj";
var _25 = "notification-t1HYH";
var _26 = "slider-2DMz6";
var _27 = "passengers__names-19GrG";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "tabletMiddle", _5 as "passengers", _6 as "passengers_recommend", _7 as "passengers_mobile", _8 as "passenger_fixed", _9 as "passenger_stickToBottom", _a as "passenger", _b as "passenger__name", _c as "free", _d as "passenger__name__value", _e as "passenger__cancel", _f as "passenger__seat", _10 as "passenger__price", _11 as "passenger_selected", _12 as "disclaimer", _13 as "passenger__icon", _14 as "passenger_withoutSeat", _15 as "passenger_with_seat", _16 as "passenger_with_confirmed_seat", _17 as "passengers__footer", _18 as "passengers__buttons", _19 as "passengers__button", _1a as "passengers__button_clear", _1b as "info__icon", _1c as "disclaimer__paragraph", _1d as "recommend", _1e as "recommend__icon", _1f as "recommend__wrapper", _20 as "recommend__label", _21 as "together", _22 as "recommend__price", _23 as "passengers__doubleSeat", _24 as "notifications", _25 as "notification", _26 as "slider", _27 as "passengers__names" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "tabletMiddle": _4, "passengers": _5, "passengers_recommend": _6, "passengers_mobile": _7, "passenger_fixed": _8, "passenger_stickToBottom": _9, "passenger": _a, "passenger__name": _b, "free": _c, "passenger__name__value": _d, "passenger__cancel": _e, "passenger__seat": _f, "passenger__price": _10, "passenger_selected": _11, "disclaimer": _12, "passenger__icon": _13, "passenger_withoutSeat": _14, "passenger_with_seat": _15, "passenger_with_confirmed_seat": _16, "passengers__footer": _17, "passengers__buttons": _18, "passengers__button": _19, "passengers__button_clear": _1a, "info__icon": _1b, "disclaimer__paragraph": _1c, "recommend": _1d, "recommend__icon": _1e, "recommend__wrapper": _1f, "recommend__label": _20, "together": _21, "recommend__price": _22, "passengers__doubleSeat": _23, "notifications": _24, "notification": _25, "slider": _26, "passengers__names": _27 }
